import React from 'react';
import HomeDashboardLayout from '../HomeDashboardLayout';
import MyWalletSidebar from '../MyWalletSidebar';
import '../DashboardSkeleton.css';
import './ArticleDetailShimmer.css';

const Line = ({ className = '' }) => <span className={`dashboard-skeleton article-detail-shimmer__line ${className}`} />;

export function ArticleCommentsShimmer({ label = 'Loading comments' }) {
  return <div role="status" aria-label={label}>
    <span className="visually-hidden">{label}...</span>
    <div aria-hidden="true" className="article-detail-shimmer__comments">
      {[0, 1, 2].map((row) => <div key={row} className="article-detail-shimmer__comment">
        <Line className="article-detail-shimmer__avatar" />
        <div><Line className="article-detail-shimmer__short" /><Line /><Line className="article-detail-shimmer__medium" /></div>
      </div>)}
    </div>
  </div>;
}

export default function ArticleDetailShimmer() {
  return <HomeDashboardLayout showHeader={false} variant="article-detail-layout">
    <div className="categories-page qbank-detail-page detailArticle" role="status" aria-label="Loading article" aria-busy="true">
      <span className="visually-hidden">Loading article...</span>
      <div aria-hidden="true">
        <div className="categories-page-header">
          <Line className="article-detail-shimmer__avatar" />
          <Line className="article-detail-shimmer__short" />
          <Line className="article-detail-shimmer__avatar" />
        </div>
        <div className="qb-Detail-content"><div className="d-flex qbank-detail-main">
          <section className="qbank-LeftContent"><div className="qbank-card qbank-card--question">
            <Line className="article-detail-shimmer__short" />
            <div className="article-detail-shimmer__titleRow"><Line className="article-detail-shimmer__title" /><Line className="article-detail-shimmer__pill" /></div>
            <div className="article-categories"><Line className="article-detail-shimmer__pill" /><Line className="article-detail-shimmer__pill" /></div>
            <div className="article-detail-shimmer__body">
              {Array.from({ length: 14 }, (_, row) => <Line key={row} className={row % 4 === 3 ? 'article-detail-shimmer__medium' : ''} />)}
            </div>
            <div className="article-tags"><Line className="article-detail-shimmer__pill" /><Line className="article-detail-shimmer__pill" /></div>
            <div className="article-detail-shimmer__actions">{[0, 1, 2, 3].map((action) => <Line key={action} className="article-detail-shimmer__short" />)}</div>
          </div></section>
          <aside className="qbank-rightContent">
            <Line className="article-detail-shimmer__short" />
            <Line className="article-detail-shimmer__input" />
            <Line className="article-detail-shimmer__pill" />
            <ArticleCommentsShimmer />
          </aside>
        </div></div>
      </div>
    </div>
    <MyWalletSidebar withTopOffset={false} />
  </HomeDashboardLayout>;
}
